const messages = {
  threads: {
    orders: {
      title: "Ihre Bestellung im Prämienshop",
      content:
        "<p>Sehr geehrter Kunde,<br><br></p>\n<p>vielen Dank f&uuml;r Ihre Bestellung im Pr&auml;mienshop:&nbsp;</p>\n<p>- &nbsp;&gt;&gt;ORDER-ID&lt;&lt;&nbsp;</p>\n<p>- &nbsp;&gt;&gt;ORDER-PRODUCTS&lt;&lt;&nbsp;</p>\n<p>&nbsp;&gt;&gt;ORDER-ADDRESS&lt;&lt;&nbsp;</p>\n<p>Ihre &nbsp;Bestellung wird nun bearbeitet.<br>Die Auslieferung kann bis zu 3 Wochen in Anspruch nehmen.<br><br>Beste Gr&uuml;&szlig;e<br><br>Ihr BRIDGESTONE PLUS Team</p>",
    },
    externalTraining: {
      title: "Bridgestone Schulungen - Ihre Anfrage",
      content:
        "<p>Sehr geehrter Kunde,</p>\n<p>vielen Dank f&uuml;r IHre Anc<br /><br />&nbsp;&gt;&gt;EXTERNAL_TRAINING_POINTS&lt;&lt;&nbsp;</p>\n<p>&nbsp;</p>\n<p>alsjkdjhqldkjxal&ouml;</p>",
    },
    InvestmentSupport: {
      title: "Ihre Anfrage zur Investitionsunterstützung",
      content:
        "<p>Sehr geehrter Kunde,<br /><br /></p>\n<p>vielen Dank f&uuml;r Ihre Anfrage zur Investitionsunterst&uuml;tzung.</p>\n<p>&nbsp;&gt;&gt;ORDER-ID&lt;&lt;&nbsp;</p>\n<p><br />Wir pr&uuml;fen Ihre Anfrage nun und Sie erhalten in den n&auml;chsten 1-2 Wochen eine R&uuml;ckmeldung.<br /><br />Die Punkte, die Sie f&uuml;r die Bestellung eingesetzt haben, wurden Ihrem Punktekonto abgezogen.<br />Kommt die Investitionsunterst&uuml;tzung nicht zustande, so werden Ihnen die Punkte selbstverst&auml;ndlich wieder gutgeschrieben.<br /><br />Beste Gr&uuml;&szlig;e<br /><br />Ihr BRIDGESTONE PLUS Team</p>",
    },
    onlineTraining: {
      title: "Ihre Teilnahme am Online-Training",
      content:
        "<p>Sehr geehrter Kunde,</p>\n<p>vielen Dank f&uuml;r Ihre Teilnahme am Online-Training <strong>&nbsp;&gt;&gt;ONLINE_TRAINING_TITLE&lt;&lt;</strong> &nbsp;und dem Quiz.<br><br><br><br>Beste Gr&uuml;&szlig;e<br><br>Ihr BRIDGESTONE PLUS Team&nbsp;<br><br></p>",
    },
    bTraining: {
      title: "Bridgestone Schulungen - Ihre Anfrage",
      content:
        "<p>Sehr geeehrte Teilnehmerin, sehr geehrter Teilnehmer,</p>\n<p>&nbsp;</p>\n<p>vielen Dank f&uuml;r Ihre Anfrage zur Teilnahme an der Bridgestone Schulung:<br /><br /><strong>- &nbsp;&gt;&gt;BRIDGESTONE_TRAINING_TITLE&lt;&lt;&nbsp;</strong></p>\n<p><br />Ihre Anfrage wird nun berarbeitet. Die Bearbeitung kann bis zu 2 Wochen in Anspruch nehmen.<br />Sollten Sie Pr&auml;mienpunkte f&uuml;r diese Anfrage eingesetzt haben, so wurden Ihnen diese von Ihrem Punktekonto bereits abgezogen.</p>\n<p>&nbsp;</p>\n<p>Beste Gr&uuml;&szlig;e<br /><br />Ihr BRIDGESTONE PLUS Team</p",
    },
    hunter: {
      title: "Beispiel einer Hunter-Produktnachricht",
      content: "Beispiel einer Hunter-Produktnachricht",
    },
    profileComplete: {
      title: "Profilvervollständigung - herzlichen Glückwunsch",
      content:
        "<p>Sehr geehrter Kunde,<br /><br /></p>\n<p>Sie haben Ihr Benutzerprofil vervollst&auml;ndigt!<br /><br /><strong>Wir bedanken uns daf&uuml;r herzlich mit 200 Pr&auml;mienpunkten</strong>, <br />die bereits Ihrem Punktekonto gutgeschrieben sind.</p>\n<p><br />Beste Gr&uuml;&szlig;e</p>\n<p>Ihr BRIDGESTONE PLUS Team</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>",
    },
    activeUser: {
      title: "Ihre Anmeldung ist freigegeben",
      content:
        "Sehr geehrter Teilnehmer,<br/><br/>Ihre Anmeldung auf BRIDGESTONE PLUS wurde geprüft und freigegeben. <br/>Wir wünschen Ihnen viel Freude und Erfolg mit BRIDGESTONE PLUS.<br/></br/>Auf eine weiterhin gute Zusammenarbeit!<br/><br/>Ihr BRIDGESTONE PLUS Team",
    },
    deleteItemFromOrder: {
      title: "Artikel aus der Bestellung gelöscht",
      content:
        "<p>Ihre Bestellung &gt;&gt;ORDER-ID&lt;&lt; wurde vom Administrator geändert.</p>&gt;&gt;ORDER-REMOVED-PRODUCTS&lt;&lt;",
    },
    deleteOrder: {
      title: "Ihre Bestellung wurde storniert",
      content:
        "<p>Ihre Bestellung &gt;&gt;ORDER-ID&lt;&lt; wurde storniert und Ihre Punkte wurden wiederhergestellt</p>",
    },
    commitmentLetter: {
      title: "AGBs & Teilnahmebedingungen",
      content:
        '<p data-renderer-start-pos="1">Sehr geehrter BRIDGESTONE PLUS-Benutzer,</p>\n<p data-renderer-start-pos="266">vielen Dank f&uuml;r das Akzeptieren der "AGB &amp; Teilnahmeberechtigungen". Das Dokument k&ouml;nnen Sie <strong data-renderer-mark="true"><a href="https://app-d-bsplus-api.azurewebsites.net/Condition_of_Participation_de.pdf">hier</a></strong>&nbsp;als pdf. herunterladen. Wir w&uuml;nschen Ihnen viel Spa&szlig; mit BRIDGESTONE PLUS. Wenn Sie weitere Fragen oder Anmerkungen haben, beantworten wir diese gerne. Gehen Sie dazu auf die Kontaktseite in BRIDGESTONE PLUS.</p>\n<p data-renderer-start-pos="601">Mit freundlichen Gr&uuml;&szlig;en</p>\n<p data-renderer-start-pos="626">Ihr BRIDGESTONE PLUS Team</p>',
    },
    uberall: {
      title: "Uberall-Abonnement",
      content: "<p>Ihr Uberall-Abonnement wurde gekauft</p>",
    },
    welcome: { title: "", content: "" },
    booster: {
      title: "Ihre doppelten Marketingpunkte sind jetzt aktiviert!",
      content:
        "Lieber Benutzer, Sie erhalten Booster-Punkte. Überprüfen Sie Ihren Kontoauszug.",
    },
    orderStatus_RETURNED: {
      title: "Bestellstatus wurde geändert",
      content:
        "Bestellstatus ist Ist zurückgekommen. <p>Guten Tag,</p>\n<p>Pr&auml;mie Direkt hat uns informiert, dass das Paket zur&uuml;ckgekommen sei. Daher buchen wir die Punkte zur&uuml;ck.</p>\n<p>&nbsp;</p>\n<p>Mit freundlochen Gr&uuml;&szlig;en",
    },
    orderStatus_REJECTED: {
      title: "Bestellstatus wurde geändert",
      content:
        "Bestellstatus ist Ist zurückgekommen. <p>Guten Tag,</p>\n<p>Pr&auml;mie Direkt hat uns informiert, dass das Paket zur&uuml;ckgekommen sei. Daher buchen wir die Punkte zur&uuml;ck.</p>\n<p>&nbsp;</p>\n<p>Mit freundlochen Gr&uuml;&szlig;en",
    },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: {
      title: "Verkaufsförderungsaktionen - Ihre Anfrage",
      content:
        "<p>Sehr geehrter Kunde,</p>\n<p>&nbsp;</p>\n<p>vielen Dank f&uuml;r Ihre Anfrage und Ihr Interesse an unseren Verkaufsf&ouml;rderungsaktionen.</p>\n<p>Sie haben sich f&uuml;r folgende Aktion(en) angemeldet:</p>\n<p>&nbsp;</p>\n<p>&gt;&gt;USER_PROMOTIONS&lt;&lt;&nbsp;</p>\n<p>&nbsp;</p>\n<p>Ihr Betrieb wird innerhalb der n&auml;chsten 14 Tage in den H&auml;ndlerfinder der Aktion(en) aufgenommen und erhalten innerhalb von 2-3 Wochen die Aktionsmaterialien f&uuml;r Ihren Verkaufsraum zugesendet.</p>\n<p>&nbsp;</p>\n<p>Wir w&uuml;nschen Ihnen viel Erfolg mit unseren Aktionen.</p>\n<p><br />Ihr BRIDGSTONE PLUS Team</p>",
    },
  },
};

export default {
  messages,
};
